import { render, staticRenderFns } from "./appDownload.vue?vue&type=template&id=3ae3bab4&scoped=true&"
import script from "./appDownload.vue?vue&type=script&lang=js&"
export * from "./appDownload.vue?vue&type=script&lang=js&"
import style0 from "./appDownload.vue?vue&type=style&index=0&id=3ae3bab4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae3bab4",
  null
  
)

export default component.exports